import axios from "@/lib/request";

// ===== 通用订单相关接口 =====

// 获取通用订单列表
export const getUniversalOrderList = params => {
  return axios.request({
    url: "/v1/admin/cmn/orderflow/list",
    method: "get",
    params,
    headers: {
      AppKey: "BpLnfgDs"
    }
  });
};

// 锁定订单
export const lockOrder = data => {
  return axios.request({
    url: "/v1/admin/cmn/orderflow/lock",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      AppKey: "BpLnfgDs"
    }
  });
};

// 解锁订单
export const unlockOrder = data => {
  return axios.request({
    url: "/v1/admin/cmn/orderflow/unlock",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      AppKey: "BpLnfgDs"
    }
  });
};

// 退保
export const refundOrder = data => {
  return axios.request({
    url: "/v1/admin/cmn/orderflow/refund",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      AppKey: "BpLnfgDs"
    }
  });
};

// 变更渠道
export const updateOrderChannel = data => {
  return axios.request({
    url: "/v1/admin/cmn/orderflow/channel/update",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      AppKey: "BpLnfgDs"
    }
  });
};
